import { useState, useEffect } from 'react';

const MOBILE_MAX = 767;
const TABLET_MAX = 1279;

function getBreakpoint(width) {
  if (width <= MOBILE_MAX) return 'mobile';
  if (width <= TABLET_MAX) return 'tablet';
  return 'desktop';
}

const SIDEBAR_WIDTH = { mobile: 0, tablet: 64, desktop: 240 };
const CONTENT_PADDING = { mobile: 16, tablet: 20, desktop: 24 };

export default function useBreakpoint() {
  const [tier, setTier] = useState(() =>
    typeof window !== 'undefined' ? getBreakpoint(window.innerWidth) : 'desktop'
  );

  useEffect(() => {
    // Sync on mount in case SSR/initial value was wrong
    const current = getBreakpoint(window.innerWidth);
    if (current !== tier) setTier(current);

    let raf;
    const handle = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setTier(getBreakpoint(window.innerWidth)));
    };
    window.addEventListener('resize', handle);
    return () => {
      window.removeEventListener('resize', handle);
      cancelAnimationFrame(raf);
    };
  }, []);

  return {
    tier,
    isMobile: tier === 'mobile',
    isTablet: tier === 'tablet',
    isDesktop: tier === 'desktop',
    sidebarWidth: SIDEBAR_WIDTH[tier],
    contentPadding: CONTENT_PADDING[tier],
  };
}
